const instructionsDataInitial = [
  {
    id: "make-dough",
    name: "Make pizza dough",
    steps: [
      { text: "In a bowl, mix together #flour#, #salt# and #instant yeast#." },
      { text: "Pour in the #warm water# and *olive oil* <ingredient-amount>(1 Tbsp)</ingredient-amount> and mix again. The dough will be pretty wet and that’s ok!" },
      { text: "Knead and mix dough until it becomes cohesive. This is a different type of pizza dough; it will be kinda wet so don't sweat that too much." } 
    ]
  },
  {
    id: "spread-dough",
    name: "Spread the dough in pan",
    steps: [
      { text: "Coat the baking pan with *olive oil* <ingredient-amount>(~2 Tbsp)</ingredient-amount>" },
      { text: "While your hands are still oily, transfer the dough to baking pan" },
      { 
          text: "Spread the dough out a little bit by dimpling it with your fingers, and pushing it gently towards the edges of the pan (see photos). Only spread it out ⅓ of the way, then cover the pan with a dish towel or plastic wrap, and let it sit for 15 minutes. Going slowly will ensure the dough doesn’t rip at all.",
          timer: 15 
      },
      { 
          text: "After 15 minutes, dip your fingers in *olive oil* and spread the dough another ⅓ of the way. Wait another 15 minutes then repeat once more, dimpling & spreading the dough until it reaches the edges and corners of the pan.",
          timer: 15 
      },
      { 
          text: "Cover the pan and let it rest for 1 hour (this final rise is requried!)",
          timer: 60 
      }
    ]
  },
  {
    id: "assemble-bake",
    name: "Assemble & bake pizza",
    steps: [
      { text: "Preheat oven to _500°F_" },
      { text: "Uncover the pan and spread the #pizza sauce# (on top, smoothing it out until it reaches the edges (you don't need to leave any bare crust area)" },
      { text: "Sprinkle #mozzarella# and #cubed provolone# (if using) evenly over the top. You really want to put the cheese all the way to the edge of the pan so it gets baked onto the crust, resulting in the BEST tasting crispy, cheesy edges." },
      { text: "Add the #pepperoni cups# on top. They should be overlapping each other slightly, like a blanket of pepperoni." },
      { 
          text: "Transfer to the oven and bake for 7 minutes.",
          timer: 7 
      },
      {
          text: "Rotate the pan 180 degrees, and bake for an additional 7 minutes. Remove from oven when the edges are golden brown and the cheese is all melty and bubbling.",
          timer: 7
      }
    ]
  }
]

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/instructions', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
    const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
    if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
    acc[sectionId].push(path); // Add path to array
    return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
    // if there's an array of media for the given section
    if (mediaBySection[section.id]) {
        // add media array
        return { ...section, media: mediaBySection[section.id] };
    } else {
        return section;
    }
})